export const athleteInfoText = {
  color: "#5C5D68",
  fontSize: 14,
  textWrap: "wrap",
  maxWidth: 300,
};

export const editText = {
  color: "#54B9EA",
  fontSize: 14,
  textWrap: "wrap",
  maxWidth: 300,
  cursor: "pointer",
  marginLeft: "10px",
};

export const editableContainer = {
  display: "flex",
  alignItems: "center",
};
